import { DimmerStatus } from '@/../client-generator/generated-clients/plants';
import { Options } from 'vue-class-component';
import SceneActionGeneral from '../SceneActionGeneral';
import EnumToSelectButton from '@/views/components/EnumToSelectButton/EnumToSelectButton.vue';

@Options({
  name: 'ActionLightDimmer',
  components: {
    EnumToSelectButton,
  },
})
export default class ActionLightDimmer extends SceneActionGeneral {
  DimmerStatus = DimmerStatus;

  get isConfirmEnabled() {
    return true;
  }
}
